module.exports = __webpack_public_path__ + "img/norm-2.84715e1.png";